import { render, staticRenderFns } from "./UserManage.vue?vue&type=template&id=09b31580"
import script from "./UserManage.vue?vue&type=script&lang=ts"
export * from "./UserManage.vue?vue&type=script&lang=ts"
import style0 from "./UserManage.vue?vue&type=style&index=0&id=09b31580&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports